/*
  EUM · Home vivo (Fase 1, 2026-10-02) — el feed que cambia por visitante y lo que mide.
  Backend: GET/POST /apps/eum/inicio/{feed,eventos} (App Proxy firmado → coa backend, services/homeVivo.ts).

  · Pide el feed con un id ANÓNIMO del navegador (uuid aleatorio, localStorage). Con sesión, la identidad la pone
    Shopify (logged_in_customer_id firmado), nunca este script.
  · Brazo «vivo»: reemplaza reseñas, creadores, prueba social y momentos por lo que el servidor eligió (lo NO visto
    en 7 días primero). Brazo «fijo» o cualquier error: se queda TODO lo estático del tema (nunca un hueco).
  · Mide: vista (≥50 % visible ≥1 s, una vez por item), clic (con intención), play/completo, reacción ❤️,
    pregunta a Ara, CVV, CP (el servidor sólo guarda la zona) y scroll máximo. En lotes; al salir, con keepalive.
  · No usa librerías. Respeta prefers-reduced-motion (sin autoplay).
*/
(function () {
  if (window.__eumHomeVivo) return;
  window.__eumHomeVivo = true;
  if (!document.querySelector('[data-hv-bloque]')) return;

  var BASE = '/apps/eum/inicio';
  // `?hv=vivo|fijo`: el equipo fuerza el brazo para revisar el home. El servidor NO lo mide (no contamina el experimento).
  var HV = (location.search.match(/[?&]hv=(vivo|fijo)\b/) || [])[1] || '';
  var EXTRA = HV ? '&hv=' + HV : '';
  var MENOS_MOV = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ── id anónimo del navegador ──────────────────────────────────────────────
  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    var b = new Uint8Array(16); (window.crypto || {}).getRandomValues ? crypto.getRandomValues(b) : b.forEach(function (_, i) { b[i] = Math.random() * 256; });
    b[6] = (b[6] & 15) | 64; b[8] = (b[8] & 63) | 128;
    var h = Array.prototype.map.call(b, function (x) { return ('0' + x.toString(16)).slice(-2); }).join('');
    return h.slice(0, 8) + '-' + h.slice(8, 12) + '-' + h.slice(12, 16) + '-' + h.slice(16, 20) + '-' + h.slice(20);
  }
  var VID;
  try { VID = localStorage.getItem('eum_hv_v'); if (!VID) { VID = uuid(); localStorage.setItem('eum_hv_v', VID); } } catch (e) { VID = uuid(); }

  // ── cola de eventos ───────────────────────────────────────────────────────
  var cola = [];
  function ev(o) { cola.push(o); if (cola.length >= 40) enviar(false); }
  function enviar(saliendo) {
    if (!cola.length) return;
    var lote = cola.splice(0, 60);
    try {
      fetch(BASE + '/eventos?v=' + encodeURIComponent(VID) + EXTRA, {
        method: 'POST', keepalive: !!saliendo, credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ e: lote })
      }).catch(function () {});
    } catch (e) { /* sin red: se pierde el lote, nunca rompe la página */ }
  }
  setInterval(function () { enviar(false); }, 5000);
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') { scrollFinal(); enviar(true); } });
  window.addEventListener('pagehide', function () { scrollFinal(); enviar(true); });

  function bloqueDe(el) {
    var b = el && el.closest && el.closest('[data-hv-bloque]');
    if (b) return b.getAttribute('data-hv-bloque');
    var s = el && el.closest && el.closest('[id^="shopify-section-"]');
    var m = s && s.id.match(/__([a-z_]+)$/);
    return m ? m[1] : null;
  }
  function intencionDeEnlace(href) {
    href = String(href || '');
    if (/\/(products|collections)\//.test(href)) return 'compra';
    if (/\/(pages\/(coa|smart-coa)|apps\/eum\/portal\/(coa|verify))|coas\/.*\/pdf/.test(href)) return 'confianza';
    if (/\/pages\/(creador|registro-cannaclub|collective|collab|vender)/.test(href)) return 'comunidad';
    if (/\/pages\/b2b/.test(href)) return 'b2b';
    if (/shipping|envio/.test(href)) return 'envio';
    return 'explora';
  }

  // ── vistas reales: ≥50 % visible durante ≥1 s, una vez por item ─────────────
  var vistos = {}, temporizadores = new WeakMap();
  var ioVista = 'IntersectionObserver' in window ? new IntersectionObserver(function (entradas) {
    entradas.forEach(function (en) {
      var el = en.target, id = el.getAttribute('data-hv-item');
      if (!id || vistos[id]) return;
      if (en.isIntersecting && en.intersectionRatio >= 0.5) {
        temporizadores.set(el, setTimeout(function () { vistos[id] = 1; ev({ t: 'vista', i: id, b: bloqueDe(el) }); }, 1000));
      } else if (temporizadores.has(el)) { clearTimeout(temporizadores.get(el)); temporizadores.delete(el); }
    });
  }, { threshold: [0, 0.5, 1] }) : null;
  function observar(raiz) { if (ioVista) (raiz || document).querySelectorAll('[data-hv-item]').forEach(function (el) { ioVista.observe(el); }); }

  // ── videos LIGEROS (snippets/eum-video-ligero.liquid): nada baja hasta que hace falta ─────────
  // Medido 2026-10-02 en frío (iPhone, 4G): 16 MB de video bajaban al abrir → LCP 3.0 s. Ahora la fuente vive en
  // data-src: «carga» = el fondo de la portada, DESPUÉS de que la página ya se ve; «vista» = al aparecer en pantalla.
  // Con «ahorro de datos» o «reducir movimiento», sólo el póster (y si el usuario toca play, ahí sí baja).
  var AHORRO = MENOS_MOV || !!(navigator.connection && navigator.connection.saveData);
  // Pósters «vista» en data-poster (snippets/eum-video-ligero.liquid): un `poster=` baja al abrir la página y 17 de
  // ellos (~700 KB) le peleaban la red a la imagen LCP de la portada. Se ponen cuando su sección se acerca (todos los de
  // esa sección: los carruseles recortan a los de al lado y el observer no los vería) y, por si acaso, todos tras `load`.
  function ponerPoster(v) { var p = v.getAttribute('data-poster'); if (p) { v.setAttribute('poster', p); v.removeAttribute('data-poster'); } }
  function postersDe(raiz) { (raiz || document).querySelectorAll('video[data-poster]').forEach(ponerPoster); }
  var ioPoster = 'IntersectionObserver' in window ? new IntersectionObserver(function (entradas) {
    entradas.forEach(function (en) {
      if (!en.isIntersecting) return;
      ioPoster.unobserve(en.target);
      postersDe(en.target.closest('[data-hv-bloque]') || en.target.parentNode);
    });
  }, { rootMargin: '600px 0px' }) : null;
  if (ioPoster) document.querySelectorAll('video[data-poster]').forEach(function (v) { ioPoster.observe(v); });
  else postersDe();
  if (document.readyState === 'complete') setTimeout(postersDe, 1200);
  else window.addEventListener('load', function () { setTimeout(postersDe, 1200); });
  function ponerFuente(v) {
    ponerPoster(v);
    var s = v.querySelector('source[data-src]');
    if (!s || s.getAttribute('src')) return false;
    // La ligera (480p) se deriva por nombre en Liquid; si el CDN no la tuviera, regresa a la original sin romper el video.
    var respaldo = s.getAttribute('data-src-respaldo');
    if (respaldo) s.addEventListener('error', function () {
      if (s.getAttribute('src') === respaldo) return;
      s.setAttribute('src', respaldo); v.load();
      if (!AHORRO) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    }, { once: true });
    s.setAttribute('src', s.getAttribute('data-src')); v.load(); return true;
  }
  function cargarFondo() {
    if (AHORRO) return;
    document.querySelectorAll('video[data-hv-diferido="carga"]').forEach(function (v) {
      ponerFuente(v);
      v.addEventListener('playing', function () { v.classList.add('eum-vivo-portada__video--lista'); }, { once: true });
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    });
  }
  if (document.readyState === 'complete') setTimeout(cargarFondo, 1200);
  else window.addEventListener('load', function () { setTimeout(cargarFondo, 1200); });
  // Un video con controles nativos sin fuente todavía: el primer toque de «play» la pone.
  document.addEventListener('play', function (e) {
    var v = e.target;
    if (v && v.tagName === 'VIDEO' && ponerFuente(v)) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  }, true);

  // ── videos: autoplay silencioso al verse, tap = sonido; play / completo ─────
  var ioVideo = 'IntersectionObserver' in window ? new IntersectionObserver(function (entradas) {
    entradas.forEach(function (en) {
      var v = en.target;
      if (en.isIntersecting && en.intersectionRatio >= 0.6) {
        if (!AHORRO) { ponerFuente(v); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      }
      else if (!v.paused) v.pause();
    });
  }, { threshold: [0, 0.6] }) : null;
  function prepararVideos(raiz) {
    (raiz || document).querySelectorAll('[data-hv-bloque] [data-hv-item] video').forEach(function (v) {
      if (v.__hv) return; v.__hv = 1;
      var tarjeta = v.closest('[data-hv-item]'), id = tarjeta && tarjeta.getAttribute('data-hv-item');
      var nativo = v.controls;   // con controles del navegador (prueba social): se mide, y un toque corto sólo le quita el mudo (abajo)
      v.muted = true; v.playsInline = true; v.setAttribute('playsinline', ''); if (!nativo) v.loop = false;
      if (ioVideo) ioVideo.observe(v);
      var jugado = false, completo = false;
      v.addEventListener('play', function () { if (!jugado && id) { jugado = true; ev({ t: 'play', i: id, b: bloqueDe(v) }); } });
      v.addEventListener('timeupdate', function () {
        if (!completo && id && v.duration && v.currentTime / v.duration >= 0.9) { completo = true; ev({ t: 'completo', i: id, b: bloqueDe(v), ms: Math.round(v.currentTime * 1000) }); }
      });
      if (nativo) {
        // El toque (sonido / pausa / reproduce) lo atiende assets/eum-video-toque.js para todo video con controles.
        return;
      }
      v.addEventListener('ended', function () { v.currentTime = 0; if (!MENOS_MOV) v.play().catch(function () {}); });
      v.addEventListener('click', function (e) {
        e.preventDefault(); v.muted = !v.muted;
        if (tarjeta) tarjeta.classList.toggle('eum-vivo-historia--sonido', !v.muted);
        if (v.paused) v.play().catch(function () {});
      });
    });
  }

  // ── reacciones ❤️ (la señal de sentimiento explícita) ────────────────────────
  var reacc = {};
  try { reacc = JSON.parse(localStorage.getItem('eum_hv_r') || '{}') || {}; } catch (e) { reacc = {}; }
  function pintarReacciones(raiz) {
    (raiz || document).querySelectorAll('[data-hv-react]').forEach(function (b) {
      var id = b.getAttribute('data-hv-react'); b.setAttribute('aria-pressed', reacc[id] ? 'true' : 'false');
    });
  }

  // ── delegación de clics: enlaces, reacciones, Ara ──────────────────────────
  document.addEventListener('click', function (e) {
    var r = e.target.closest && e.target.closest('[data-hv-react]');
    if (r) {
      e.preventDefault();
      var id = r.getAttribute('data-hv-react'), on = !reacc[id];
      if (on) reacc[id] = 1; else delete reacc[id];
      try { localStorage.setItem('eum_hv_r', JSON.stringify(reacc)); } catch (x) {}
      r.setAttribute('aria-pressed', on ? 'true' : 'false');
      r.classList.remove('eum-vivo-react--pop'); void r.offsetWidth; if (on) r.classList.add('eum-vivo-react--pop');
      ev({ t: 'reaccion', i: id, b: bloqueDe(r), on: on });
      return;
    }
    var q = e.target.closest && e.target.closest('[data-ara-pregunta]');
    if (q && q.closest('[data-hv-bloque]')) { ev({ t: 'pregunta_ara', b: bloqueDe(q), q: q.getAttribute('data-ara-pregunta') }); return; }
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || !a.closest('[id^="shopify-section-template"]')) return;
    var item = a.closest('[data-hv-item]');
    ev({ t: 'clic', i: item ? item.getAttribute('data-hv-item') : null, b: bloqueDe(a), d: a.getAttribute('href'), n: a.getAttribute('data-hv-intencion') || intencionDeEnlace(a.getAttribute('href')) });
  }, true);

  // CVV (confianza) y CP (envío): sólo el hecho; el servidor guarda la zona del CP, nunca el CP completo.
  document.addEventListener('submit', function (e) { if (e.target.closest && e.target.closest('[data-eum-vivo-cvv]')) ev({ t: 'cvv', b: 'laboratorio' }); }, true);
  document.addEventListener('click', function (e) {
    var raiz = e.target.closest && e.target.closest('[data-eum-promesa-envio]');
    if (!raiz || !e.target.closest('button')) return;
    var i = raiz.querySelector('input'); var cp = i && String(i.value || '').replace(/\D/g, '');
    if (cp && cp.length === 5) ev({ t: 'cp', b: bloqueDe(raiz), cp: cp });
  }, true);

  // scroll máximo (una vez al salir)
  var maxScroll = 0, scrollMandado = false;
  window.addEventListener('scroll', function () {
    var h = document.documentElement.scrollHeight - innerHeight; if (h > 0) maxScroll = Math.max(maxScroll, Math.round(100 * scrollY / h));
  }, { passive: true });
  function scrollFinal() { if (!scrollMandado && maxScroll > 0) { scrollMandado = true; ev({ t: 'scroll', p: Math.min(100, maxScroll) }); } }

  // ── pintar el feed ─────────────────────────────────────────────────────────
  // Imágenes del CDN de Shopify al ancho que se ve (un póster completo pesa ~160 KB; a 540 px, ~80 KB). Otros hosts, igual.
  function chica(u, w) {
    u = String(u || '');
    if (!/(cdn\.shopify\.com|\/cdn\/shop\/)/.test(u) || /[?&]width=/.test(u)) return u;
    return u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=' + w;
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function corazon(id) { return '<button type="button" class="eum-vivo-react" data-hv-react="' + esc(id) + '" aria-label="Me gusta" aria-pressed="false"><span aria-hidden="true">♥</span></button>'; }
  function barras(n, i) { var s = ''; for (var k = 0; k < n; k++) s += '<i' + (k === i ? ' class="on"' : '') + '></i>'; return '<div class="eum-vivo-resena__barras" aria-hidden="true">' + s + '</div>'; }

  function tarjetaResena(r, i, n) {
    var inicial = esc((r.autor || 'C').charAt(0).toUpperCase());
    // Foto del CLIENTE si está aprobada; si no, la foto OFICIAL del producto, presentada como producto (no como si
    // la hubiera tomado el cliente); sin ninguna, el fondo de marca.
    var imgProd = !r.foto && r.producto && r.producto.imagen;
    var clase = r.foto ? '' : (imgProd ? ' eum-vivo-resena--producto' : ' eum-vivo-resena--texto');
    var media = r.foto
      ? '<div class="eum-vivo-resena__foto"><img src="' + esc(chica(r.foto, 540)) + '" alt="Foto de la reseña de ' + esc(r.autor) + '" loading="lazy" width="540" height="960"></div>'
      : (imgProd ? '<div class="eum-vivo-resena__producto-img"><img src="' + esc(chica(r.producto.imagen, 540)) + '" alt="' + esc(r.producto.titulo) + '" loading="lazy" width="360" height="360"></div>' : '');
    return '<article class="eum-vivo-resena' + clase + '" role="listitem" data-hv-item="' + esc(r.id) + '">' + media +
      barras(Math.min(n, 5), i % 5) +
      '<div class="eum-vivo-resena__quien"><span class="eum-vivo-resena__avatar" aria-hidden="true">' + inicial + '</span><span><b>' + esc(r.autor) + '</b><small>' + (r.confianza === 'importada' ? '' : '✓ ') + esc(r.insignia) + '</small></span></div>' +   // la importada NO lleva palomita: no está verificada
      corazon(r.id) +
      '<div class="eum-vivo-resena__cuerpo"><span class="eum-vivo-resena__estrellas" aria-label="' + r.estrellas + ' de 5">' + new Array(r.estrellas + 1).join('★') + '</span>' +
      '<p class="eum-vivo-resena__texto">«' + esc(r.texto) + '»</p>' +
      (r.producto ? '<a class="eum-vivo-resena__producto" data-hv-intencion="compra" href="' + esc(r.producto.url) + '">' + esc(r.producto.titulo) + '</a>' : '') + '</div></article>';
  }
  // Textos editables en el editor de temas: viven como data-hv-txt-* en el rail de la sección.
  function txt(clave, k, def) { var r = document.querySelector('[data-hv-rail="' + clave + '"]'); return (r && r.getAttribute('data-hv-txt-' + k)) || def; }
  function tarjetaVideo(c, i, n, clave) {
    var prod = c.producto ? '<a class="eum-vivo-resena__producto" data-hv-intencion="' + (c.tipo === 'emprende' ? 'b2b' : 'compra') + '" href="/products/' + esc(c.producto) + '">' + esc(txt(clave, 'producto', 'Ver el producto')) + '</a>' : '';
    return '<article class="eum-vivo-resena eum-vivo-historia" role="listitem" data-hv-item="' + esc(c.id) + '">' +
      '<div class="eum-vivo-resena__foto"><video src="' + esc(c.video) + '" poster="' + esc(chica(c.poster, 540)) + '" muted playsinline preload="none" aria-label="' + esc(c.titulo) + '"></video></div>' +
      barras(Math.min(n, 5), i % 5) +
      '<div class="eum-vivo-resena__quien"><span class="eum-vivo-resena__avatar" aria-hidden="true">' + esc((c.cuenta || 'E').charAt(0)) + '</span><span><b>' + esc(c.cuenta) + '</b><small>' + esc(txt(clave, 'sonido', 'Toca para activar el sonido')) + '</small></span></div>' +
      corazon(c.id) +
      '<div class="eum-vivo-resena__cuerpo"><p class="eum-vivo-resena__texto">' + esc(c.titulo) + '</p>' + prod + '</div></article>';
  }
  function tarjetaMomento(m) {
    return '<article class="eum-vivo-momento" role="listitem" data-hv-item="' + esc(m.id) + '">' +
      '<p class="eum-vivo__kicker">' + esc(m.etiqueta) + '</p><h3 class="eum-vivo-momento__gancho">' + esc(m.gancho) + '</h3>' +
      '<details class="eum-vivo-momento__mas"><summary>' + esc(txt('momentos', 'respuesta', 'Ver la respuesta')) + '</summary><p>' + esc(m.respuesta) + '</p>' +
      (m.fuente ? '<p class="eum-vivo__sub" style="font-size:1.2rem">Fuente: ' + esc(m.fuente) + '</p>' : '') + '</details>' +
      corazon(m.id) +
      (m.enlace ? '<a class="btn btn--underline" data-hv-intencion="confianza" href="' + esc(m.enlace.url) + '">' + esc(m.enlace.texto) + '</a>' : '') + '</article>';
  }
  function rellenar(clave, html) {
    document.querySelectorAll('[data-hv-rail="' + clave + '"]').forEach(function (rail) {
      if (!html) return;
      rail.innerHTML = html; prepararVideos(rail); observar(rail); pintarReacciones(rail);
      var sec = rail.closest('[data-hv-oculto]'); if (sec) sec.removeAttribute('hidden');
    });
  }
  function pintarCifras(c) {
    if (!c) return;
    document.querySelectorAll('[data-hv-cifra]').forEach(function (el) {
      var k = el.getAttribute('data-hv-cifra'), b = el.querySelector('b'), s = el.querySelector('span');
      if (k === 'promedio' && c.promedio && c.resenas) { b.textContent = c.promedio + ' ★'; s.textContent = c.resenas + ' reseñas de compra verificada'; }
      if (k === 'certificados' && c.certificados) b.textContent = c.certificados;
      if (k === 'verificaciones' && c.verificaciones) b.textContent = c.verificaciones;
    });
  }

  // ── «Para ti»: lo que Ara y el CRM saben de esta persona (sólo brazo vivo + sesión) ──────────────
  // El servidor manda ENFOQUES (sin datos personales): los bloques que le importan suben justo después de la prueba
  // social. Nada se oculta: sólo cambia el orden. La recompra cercana (Oracle) se dice en el saludo.
  var BLOQUE_DE = { envio: 'envio', confianza: 'laboratorio', producto: 'ara', b2b: 'creadores_emprende' };
  function paraTi(p) {
    if (!p) return;
    // El editor puede fijar el orden (portada → «Subir las secciones que le importan…» apagado).
    var ancla = document.querySelector('[data-hv-reordenar="no"]') ? null : document.querySelector('[data-hv-bloque="prueba_social"]');
    ancla = ancla && ancla.closest('[id^="shopify-section-"]');
    (p.enfoques || []).slice().reverse().forEach(function (e) {
      var b = BLOQUE_DE[e]; if (!b || !ancla) return;
      var el = document.querySelector('[data-hv-bloque="' + b + '"]'); var sec = el && el.closest('[id^="shopify-section-"]');
      if (sec && sec !== ancla) ancla.parentNode.insertBefore(sec, ancla.nextSibling);
    });
    var hola = document.querySelector('.eum-vivo-portada__hola p');
    if (hola && p.proxima_en_dias !== null && p.proxima_en_dias !== undefined) {
      var d = p.proxima_en_dias;
      hola.insertAdjacentHTML('beforeend', ' <span class="eum-vivo-portada__recompra">' + (d <= 1 ? 'Por tu ritmo, tu siguiente pedido suele tocar ya.' : 'Por tu ritmo, tu siguiente pedido suele tocar en unos ' + d + ' días.') + '</span>');
    }
  }

  // Lo estático ya mide desde el primer momento (brazo «fijo» = control).
  prepararVideos(); observar(); pintarReacciones();
  // Videos «vista» fuera de una tarjeta medida (p. ej. el de Ara): también se cargan sólo al aparecer.
  if (ioVideo) document.querySelectorAll('video[data-hv-diferido="vista"]').forEach(function (v) { ioVideo.observe(v); });

  fetch(BASE + '/feed?v=' + encodeURIComponent(VID) + EXTRA, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (f) {
      if (!f || !f.ok) return;
      document.documentElement.setAttribute('data-hv-brazo', f.brazo);
      pintarCifras(f.cifras);
      if (f.brazo !== 'vivo') return;
      paraTi(f.para_ti);
      var R = f.resenas || [], C = f.creadores_consumo || [], E = f.creadores_emprende || [], M = f.momentos || [];
      if (R.length) rellenar('resenas', R.map(function (r, i) { return tarjetaResena(r, i, R.length); }).join(''));
      if (C.length) rellenar('creadores_consumo', C.map(function (c, i) { return tarjetaVideo(c, i, C.length, 'creadores_consumo'); }).join(''));
      if (E.length) rellenar('creadores_emprende', E.map(function (c, i) { return tarjetaVideo(c, i, E.length, 'creadores_emprende'); }).join(''));
      if (M.length) rellenar('momentos', M.map(tarjetaMomento).join(''));
    })
    .catch(function () { /* se queda lo estático */ });
})();
